import { Bag as CartIcon } from "@phosphor-icons/react"

export default CartIcon
